import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemParametersDto } from '@nebula-shared/domain';
import { API_CONFIG } from '../crud/api.config';
import { HttpService } from '../http/http.service';

export type Module = Exclude<keyof typeof API_CONFIG, 'budgetExecution'>;

@Injectable({
  providedIn: 'root',
})
export class DateRangePickerServices {
  protected http = inject(HttpService);

  getSystemParams(module: Module): Observable<SystemParametersDto> {
    const config = API_CONFIG[module];
    if (module === 'invoicing')
      return this.http.getContent<SystemParametersDto>(
        `${config.baseUrl}/parametros-facturacion/date`,
      );
    return this.http.getContent<SystemParametersDto>(
      `${config.baseUrl}${config.endpoints?.parametrosSistema}/system-date`,
    );
  }
}
